<template>
  <v-app-bar
      color="primary" dense dark flat
      :max-height="48">
    <v-toolbar-title style="height: 32px;">
      <img
          src="logo.png"
          style="height: inherit; width: inherit; object-fit: contain;"
      />
    </v-toolbar-title>

    <v-spacer />
    <header-language-selector class="language-selector"/>

    <span class="mr-3" />

    <span class="mr-3" />

    <!-- ИМЯ ПОЛЬЗОВАТЕЛЯ -->
    <span v-if="profile !== null" style="font-weight: 300;">
      {{ profile.username }}
    </span>

    <!-- КНОПКА ВЫХОДА -->
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-btn
            icon
            small
            class="ml-3 mr-1"
            v-on="on"
            @click="logOut"
        >
          <v-icon size="16">
            fas fa-sign-out-alt
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('home.logout') }}</span>
    </v-tooltip>
  </v-app-bar>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import Cookies from 'js-cookie'
import { deleteCookieWithDote } from '@/utils/helpers'
import HeaderLanguageSelector from '@/components/languages/HeaderLanguageSelector.vue'

export default {
  name: 'MainTopBar',

  components: { HeaderLanguageSelector },

  data() {
    return {
      // profile: null
    }
  },

  computed: {
    ...mapFields('main', ['profile'])
  },

  methods: {
    logOut() {
      deleteCookieWithDote('dolphinAntyAccessToken')
      deleteCookieWithDote('dolphinAntyRefreshToken')

      Cookies.remove('dolphinAntyAccessToken')
      Cookies.remove('dolphinAntyRefreshToken')
      localStorage.removeItem('isEmailConfirmed')
      this.$store.dispatch('auth/setIsAuthenticated', '')
      this.$store.dispatch('main/setProfile', {})

      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style lang="scss">
.language-selector {
  cursor: pointer;
  width: 40px;
  border-radius: 6px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.20);
}

.language-selector:hover {
  background: rgba(196, 76, 255, 0.85);
}
</style>
